export default {
  name: 'ContentBlockColumns',
  components: {},
  props: {
    data: {
      type: Object,
      default: ''
    },
    positionCenter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {}
};
